// src/config/blockThemes.js
const blockThemes = [
  {
    style: {
      "--theme-color": "white",
      "--theme-high-contrast-color": "var(--lightgrey)",
      "--theme-foreground-color": "var(--grey)",
      "--theme-low-contrast-foreground-color": "var(--grey)",
    },
    name: "default",
    label: "Default",
  },
  {
    style: {
      "--theme-color": "var(--grey-bg)",
      "--theme-high-contrast-color": "var(--charcoal)",
      "--theme-foreground-color": "var(--charcoal)",
      "--theme-low-contrast-foreground-color": "var(--grey-bg)",
    },
    name: "lightgrey",
    label: "Light Grey",
  },
  {
    style: {
      "--theme-color": "var(--cobalt)",
      "--theme-high-contrast-color": "white",
      "--theme-foreground-color": "white",
      "--theme-low-contrast-foreground-color": "var(--cobalt)",
    },
    name: "cobalt",
    label: "Cobalt",
  },
  {
    style: {
      "--theme-color": "var(--cobalt-dark)",
      "--theme-high-contrast-color": "white",
      "--theme-foreground-color": "white",
      "--theme-low-contrast-foreground-color": "var(--cobalt-dark)",
    },
    name: "cobalt-dark",
    label: "Dark Cobalt",
  },
];

export default blockThemes;
